module.exports = __webpack_public_path__ + "img/ic-eau.1ebe2315.svg";